import React, { useEffect } from 'react'
import { AppBar, Button } from '@material-ui/core';
import { Switch, Route, useHistory } from 'react-router-dom'
import Gifts from './Gifts';
import Rewards from './Rewards'
import Stats from './Stats';
import Keys from './Keys';
import Avatars from './Avatars'
import Leaderboard from './Leaderboard';
import SendCredit from './SendCredit';
export default function Dash({ api }) {
    const history = useHistory();
    const [loaded, setLoaded] = React.useState(false)
    const [data, setData] = React.useState({})
    useEffect(() => {
        api.axios.get("verify")
            .then(d => {
                setLoaded(true)
                setData(d)
            })
            .catch(e => {
                if (e.status === 401) {
                    localStorage.clear();
                    window.location = "/login"
                }
                else api.showSnack(e.error || 'Something went wrong.')
            })
    }, [])
    return (
        <div>
            {!loaded ? 'LOADING. . .' :
                <div>
                    <AppBar style={{ padding: 15, flexDirection: 'row' }}>
                        <h3 style={{ flex: 1 }} onClick={e => history.push("/dash")}>Dashboard</h3>
                        <Button onClick={e => {
                            localStorage.clear();
                            window.location = "/"
                        }} variant="contained" color="secondary">Logout</Button>
                    </AppBar>
                    <div style={{ marginTop: 65 }}>
                        <Switch>
                            <Route path="/dash/gifts" exact={true}>
                                <Gifts api={api} />
                            </Route>
                            <Route path="/dash/keys" exact={true}>
                                <Keys api={api} />
                            </Route>
                            <Route path="/dash/avatars" exact={true}>
                                <Avatars api={api} />
                            </Route>
                            <Route path="/dash/rewards" exact={true}>
                                <Rewards api={api} />
                            </Route>
                            <Route path="/dash/leaderboard" exact={true}>
                                <Leaderboard api={api} />
                            </Route>
                            <Route path="/dash/send-credit" exact={true}>
                                <SendCredit api={api} />
                            </Route>
                            <Route>
                                <Stats api={api} data={data} />
                            </Route>
                        </Switch>

                    </div>

                </div>}
        </div>
    )
}
